import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import ChatPanel from './ChatPanel';
import MessageInput from './MessageInput';
import { useConfigStore } from '@/stores/useConfigStore';
import { useChatStore } from '@/stores/useChatStore';

/**
 * 双栏对话视图。
 * 左右两栏并排，中间有分隔线，底部共享输入区。
 */
const DualChatView: React.FC = () => {
  const leftConfig = useConfigStore((s) => s.leftConfig);
  const rightConfig = useConfigStore((s) => s.rightConfig);
  const leftMessages = useChatStore((s) => s.leftMessages);
  const rightMessages = useChatStore((s) => s.rightMessages);
  const hasStarted = leftMessages.length > 0 || rightMessages.length > 0;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'hidden',
      }}
    >
      {/* 双栏消息区 */}
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          overflow: 'hidden',
        }}
      >
        {/* 左栏 */}
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            minWidth: 0,
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              px: 2,
              py: 1,
              borderBottom: '1px solid',
              borderColor: 'divider',
              bgcolor: 'background.paper',
            }}
          >
            <Typography variant="subtitle2" sx={{ fontWeight: 600, color: 'primary.main' }}>
              【模型A】{leftConfig.name}
            </Typography>
          </Box>
          <Box sx={{ flex: 1, overflow: 'hidden' }}>
            <ChatPanel modelLabel="left" />
          </Box>
          {hasStarted && <MessageInput target="left" compact />}
        </Box>

        {/* 中间分隔线 */}
        <Divider orientation="vertical" flexItem />

        {/* 右栏 */}
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            minWidth: 0,
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              px: 2,
              py: 1,
              borderBottom: '1px solid',
              borderColor: 'divider',
              bgcolor: 'background.paper',
            }}
          >
            <Typography variant="subtitle2" sx={{ fontWeight: 600, color: 'primary.main' }}>
              【模型B】{rightConfig.name}
            </Typography>
          </Box>
          <Box sx={{ flex: 1, overflow: 'hidden' }}>
            <ChatPanel modelLabel="right" />
          </Box>
          {hasStarted && <MessageInput target="right" compact />}
        </Box>
      </Box>

      {!hasStarted && <MessageInput target="both" />}
    </Box>
  );
};

export default DualChatView;
